module.exports = __webpack_public_path__ + "static/rldatix-logo-665c85a49c355bf157099933f003f1cc.jpeg";